import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6807e12a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import {
  MAX_CONCURRENT_REQUESTS,
  RoundStatus,
  currentRequests,
  inRetryForm,
  useGameStore
} from '@/stores/gameStore';
import { isPhone } from '@/utils/responsiveHelper';
import { onMounted, watch } from 'vue';
import { remainingTime } from '@/stores/gameStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TargetImage',
  props: ['image'],
  setup(__props) {



const gameStore = useGameStore();

const generateKeyframes = () => {
  let keyframes = '';

  const keyFrameElement = document.getElementById('progress-keyframes');

  if (keyFrameElement) {
    document.head.removeChild(keyFrameElement);
  }
  const startFraction = 1 - remainingTime.value / 60;

  for (let i = 0; i <= 1000 * (1 - startFraction); i++) {
    const adjustedFraction = startFraction + i / 1000;

    keyframes += `${i / 10}% {
              background-image: conic-gradient(#333741 ${
                adjustedFraction * 100
              }%, #b692f6 0);
            }\n`;
  }

  // Create a style element and set the keyframes
  const style = document.createElement('style');
  style.id = 'progress-keyframes';
  style.innerHTML = `
          @keyframes progress {
            ${keyframes}
          }
          `;

  document.head.appendChild(style);
};

watch(remainingTime, () => {
  if (isPhone()) {
    if (
      currentRequests.value >= MAX_CONCURRENT_REQUESTS &&
      !inRetryForm.value
    ) {
      return;
    } else {
      const circle = handleTimerFinished();
      circle.classList.add('paused');
    }
  }
});

onMounted(() => {
  if (isPhone()) {
    generateKeyframes();
  }
});

function handleTimerFinished() {
  const circle = document.querySelector('.circle') as HTMLElement;
  circle.classList.remove('paused');
  circle.style.animation = 'none';
  circle.offsetHeight; // Trigger reflow to restart the animation
  // Re-generate the keyframes
  generateKeyframes();
  circle.style.animation = 'progress 60s linear';
  return circle;
}

window.addEventListener('timerFinished', handleTimerFinished);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["circle per-25", { paused: _unref(gameStore).roundStatus !== _unref(RoundStatus).RUNNING }])
  }, [
    _createElementVNode("img", {
      src: __props.image,
      alt: "Target image",
      class: "target-image inner"
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})